import React from 'react';
import { RadioButton, Typography } from '@drone-js/core';
import { SortCode } from 'gql/autogen/SortCode';
import { SortOrder } from 'gql/autogen/SortOrder';

export interface SortItemProps {
    name: string;
    label: string;
    type: string;
    code: SortCode;
    order: SortOrder;
    selected?: boolean;
}

interface Props {
    item: SortItemProps;
    index: number;
    isLastItem?: boolean;
    onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
}

export const SortItem: React.FC<Props> = React.memo((props): React.JSX.Element => {
    const { item, onChangeHandler, isLastItem } = props;
    return (
        <RadioButton
            key={item.label}
            data-element-name="activities-sort-option"
            data-testid="activities-sort-option"
            data-element-index={props.index + 1}
            selection={item.selected ? 'selected' : 'unselected'}
            value={item.type}
            onChange={() => onChangeHandler({ target: { value: item.type } } as React.ChangeEvent<HTMLInputElement>, props.index)}
            role="radio"
            mb={!isLastItem ? '12' : '0'}
            tabIndex={item.selected ? 0 : -1}
            label={item.label}
        >
            <Typography variant="body-default">{item.label}</Typography>
        </RadioButton>
    );
});
SortItem.displayName = 'SortItem';
